import Layout from '@/layout/index.vue'
import { TEMPLATE_GUIDE, TEMPLATE_VISTEL } from '@/utils/constant'

// 基于vistel模版增加导诊模块的模版
const vistelGuideRoutes = [{
  path: `/${TEMPLATE_GUIDE}`,
  component: Layout,
  children: [
    {
      path: ':orgUid',
      redirect: `/${TEMPLATE_VISTEL}/:orgUid`
    }
  ]
}]
export default vistelGuideRoutes



// WEBPACK FOOTER //
// ./src/router/modules/vistel-guide.js